<template>
    <div>
        <a-card class="c_annualPlafon">
            <div slot="title" class="m-display-flex space-between custom">
            <span class="cmain-title"><a-icon type="project" />&nbsp;Profit Planning</span>
            <a-button v-if="show_create" type="primary" class="cbtn-create" icon ="plus" @click="showModalCreate">Create</a-button>
            </div>

            <a-row :gutter="8">
                <a-col :span="24" class="margin-bottom">
                    <a-card class="filter=card">
                        <div :class="getScreen?'m-width-full':'m-display-flex'">
                            <div :style="getScreen?'width:100%':''">
                                &nbsp;Year :&nbsp;<a-select
                                placeholder="Choose"
                                v-model="selected.year"
                                @change="changeYear" 
                                :filterOption="filterOption"
                                showSearch
                                :style="getScreen?'':'width:200px'"
                                :class="getScreen?'m-width-full':''"
                                :disabled="loading.page"
                                >
                                <a-select-option v-for="item in year" :key="item" :value="item">{{ item }}</a-select-option>
                                </a-select>
                            </div>
                        </div>
                    </a-card>
                </a-col>

                <a-col :span="24" class="margin-bottom">
                    <a-card class="custom-card">
                        <a-table 
                            size="small"
                            rowKey="key"
                            :columns="columns" 
                            :showHeader="false"
                            :data-source="data_table_header"
                            :loading="loading.table"
                            :pagination="false"
                            class="custom-table"
                            bordered>
                            <template slot="nama_pekerjaan" slot-scope="text, item">
                                <strong>{{ item.nama_pekerjaan }}</strong>
                            </template>
                            <template slot="nilai_kontrak" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.nilai_kontrak) }}
                            </template>
                            <template slot="beban_proyek" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.beban_proyek) }}
                            </template>
                            <template slot="komisi" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.komisi) }}
                            </template>
                            <template slot="laba_kotor" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.laba_kotor) }}
                            </template>
                            <template slot="omzet" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.omzet) }}
                            </template>
                            <template slot="efektivitas" slot-scope="text, item, index">
                                {{item.efektivitas}}
                            </template>
                            <template slot="revenue" slot-scope="text, item, index">
                            {{ item.revenue + ' %' }}
                            </template>
                        </a-table>
                    </a-card>
                </a-col>

                <a-col :span="24">
                    <a-card class="custom-card">
                        <a-table 
                            size="small"
                            rowKey="key"
                            :columns="columns" 
                            :data-source="data_table"
                            :loading="loading.table"
                            :pagination="false"
                            class="custom-table"
                            bordered>
                            <template slot="nama_pekerjaan" slot-scope="text, item">
                                {{ item.nama_pekerjaan }}
                            </template>
                            <template slot="nilai_kontrak" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.nilai_kontrak) }}
                            </template>
                            <template slot="beban_proyek" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.beban_proyek) }}
                            </template>
                            <template slot="komisi" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.komisi) }}
                            </template>
                            <template slot="laba_kotor" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.laba_kotor) }}
                            </template>
                            <template slot="omzet" slot-scope="text, item, index">
                                {{ customFormatCurrency('IDR', item.omzet) }}
                            </template>
                            <template slot="efektivitas" slot-scope="text, item, index">
                                {{item.efektivitas}}
                            </template>
                            <template slot="revenue" slot-scope="text, item, index">
                            {{ item.revenue + ' %' }}
                            </template>
                        </a-table>
                    </a-card>
                </a-col>
            </a-row>
        </a-card>

        <a-modal :visible="modal_create" @cancel="modalOnClose" :footer="null" :maskClosable="false" width="50%">
            <span slot="title"> <a-icon type="plus" /> Create Profit Planning</span>

            <a-form :form="form_create">
                <a-row :gutter="8">
                    <a-col>

                        <a-form-item label="Tahun">
                            <a-date-picker v-decorator="['year', { rules: [{ required: true }], initialValue: moment() } ]"
                            mode="year"
                            format="YYYY"
                            placeholder="Select year"
                            :open="yearOpen"
                            @panelChange="handleYearChange"
                            @openChange="handleOpenChange"
                            />
                        </a-form-item>

                        <a-form-item label="Kategori">
                            <a-select
                            placeholder="Pilih kategori"
                            v-model="form.category"
                            :filterOption="filterOption"
                            showSearch
                            :class="getScreen?'m-width-full':''"
                            v-decorator="['category', { rules: [{ required: true, message: 'Kategori wajib diisi' }] } ]"
                            >
                                <a-select-option v-for="item in category_opt" :key="item.option" :value="item.option">{{ item.option_label }}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="Nama Pekerjaan">
                            <a-input v-model="form.work_name"
                            v-decorator="['work_name', { rules: [{ required: true, message: 'Nama pekerjaan wajib diisi' }] } ]"></a-input>
                        </a-form-item>

                        <a-form-item label="Nilai Kontrak">
                            <a-input-number type="number" class="m-width-full m-text-align-right"
                            v-on:keydown.enter.prevent="preventEnterButton" 
                            @change="onChangeContractValue"
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                            v-decorator="['contract_value',{ rules: [{ required: true, message: 'Nilai kontrak wajib diisi' }] },]" 
                            />
                        </a-form-item>

                        <a-form-item label="Omzet">
                            <a-input-number type="number" class="m-width-full m-text-align-right"
                            v-model="form.omzet"
                            v-on:keydown.enter.prevent="preventEnterButton" 
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                            v-decorator="['omzet',{ rules: [{ required: true, message: 'Omzet wajib diisi' }] },]" 
                            />
                        </a-form-item>

                        <a-form-item label="Beban Proyek">
                            <a-input-number type="number" class="m-width-full m-text-align-right"
                            v-on:keydown.enter.prevent="preventEnterButton" 
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                            v-decorator="['beban_proyek',{ rules: [{ required: true, message: 'Beban proyek wajib diisi' }] },]" 
                            />
                        </a-form-item>

                        <a-form-item label="Komisi">
                            <a-input-number type="number" class="m-width-full m-text-align-right"
                            v-on:keydown.enter.prevent="preventEnterButton" 
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                            v-decorator="['commition_value',{ rules: [{ required: true, message: 'Komisi wajib diisi' }] },]" 
                            />
                        </a-form-item>

                        <a-form-item label="Laba Kotor">
                            <a-input-number type="number" class="m-width-full m-text-align-right"
                            v-model="form.gross_profit"
                            v-on:keydown.enter.prevent="preventEnterButton" 
                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                            v-decorator="['gross_profit',{ rules: [{ required: true, message: 'Laba kotor wajib diisi' }] },]" 
                            />
                        </a-form-item>

                        <a-form-item label="Efektivitas">
                            <a-input-number type="number" class="m-width-full m-text-align-right"
                            v-on:keydown.enter.prevent="preventEnterButton" 
                            :formatter="value => `${value}%`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            :parser="value => value.replace(/\$\s?|(,*)/g, '')" 
                            v-decorator="['efektive',{ rules: [{ required: true, message: 'Efektivitas wajib diisi' }] },]" 
                            />
                        </a-form-item>

                    </a-col>
                </a-row>
                <div class="footer-card">
                    <a-button type="secondary" html-type="submit" @click="modalOnClose">Cancel</a-button>
                    <a-button :loading="loading.submit" type="primary" html-type="submit" @click="onSubmitCreate"><b>Submit</b></a-button>
                </div>
            </a-form>
        </a-modal>
        
    </div>
</template>


<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
    mixins: [CurrencyFormat],
    data(){

        const columns = [
            {
                title: "Nama Pekerjaan",
                key: "nama_pekerjaan",
                width: 250,
                align: "left",
                fixed: "left",
                scopedSlots: { customRender: "nama_pekerjaan" },
            },
            {
                title: "Niali Kontrak",
                key: "nilai_kontrak",
                // width: 150,
                align: "right",
                scopedSlots: { customRender: "nilai_kontrak" },
            },
            {
                title: "Beban Proyek",
                key: "beban_proyek",
                // width: 150,
                align: "right",
                scopedSlots: { customRender: "beban_proyek" },
            },
            {
                title: "Komisi",
                key: "komisi",
                // width: 150,
                align: "right",
                scopedSlots: { customRender: "komisi" },
            },
            {
                title: "Laba Kotor",
                key: "laba_kotor",
                // width: 150,
                align: "right",
                scopedSlots: { customRender: "laba_kotor" },
            },
            {
                title: "Efektivitas",
                key: "efektivitas",
                // width: 150,
                align: "right",
                scopedSlots: { customRender: "efektivitas" },
            },
        ];

        return{
            modal_create: false,
            year: [],
            loading: {
                page: false,
                table: false,
                submit: false
            },
            selected: {
                year: ''
            },
            columns,
            data_table_header: [],
            data_table: [],
            category_opt: [],
            yearOpen: false,
            form:{
                year: new Date().getFullYear(),
                category: '',
                work_name: '',
                omzet: 0,
                gross_profit: 0
            },
            show_create: false
        }
    },

    computed: {
        ...mapGetters([
            "getScreen",
            "getAuth",
            "getStatus",
            "getDefaultDateFormat",
            "getStandartFormatDate",
        ]),

        dataEfektive(){
          return [this.form.omzet, this.form.gross_profit]
        }
    },

    watch: {
      dataEfektive: {
        handler([omzet, gross]){
          if(omzet > 0 && gross > 0) {
            let calculate = Number(((omzet/gross) * 100).toFixed(2))
            this.form_create.setFieldsValue({
              efektive: calculate
            })
          }
        },
        deep: true
      }
    },

    beforeCreate() {
      this.form_create = this.$form.createForm(this);
    },

    created() {
        this.selected.year = new Date().getFullYear();
    },

    mounted(){
      this.fetchData()
      if(this.getAuth.nama_bidang[0] == "Financial Control") this.show_create = true;
    },

    methods: {
        moment,
        async fetchData(){
            this.loading.table = true
            try {
                const response = await axios({
                    method: "GET",
                    url: this.$serviceUrl + "profit_planning",
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "X-API-KEY": this.getAuth.apikey,
                    },
                    params: {
                        tahun: this.selected.year
                    }
                })
                this.data_table_header = response.data.resume
                this.data_table = response.data.data
                this.year = response.data.tahun
                this.category_opt = response.data.kategori
                this.loading.table = false
            } catch (error) {
                console.log(error);
                this.loading.table = false
            }
        },

        showModalCreate(){
            this.modal_create = true
        },

        modalOnClose(){
            this.modal_create = false
            this.form_create.resetFields()
        },

        filterOption(){

        },
        changeYear(){
            this.fetchData()
        },

        handleOpenChange(status) {
            this.yearOpen = status
        },

      handleYearChange(value) {
        this.form_create.setFieldsValue({
          year: value
        })

        this.yearOpen = false
      },

      onChangeContractValue(val){
        this.form_create.setFieldsValue({
            omzet: val
        })
        this.form.omzet = val
      },

      onChangeOmzetValue(val){
        let gross_profit = this.form_create.getFieldValue('gross_profit')
        let calculate =  Number(((val / gross_profit) * 100).toFixed(2))
        this.form_create.setFieldsValue({
            efektive: calculate
        })
      },

      onSubmitCreate(){
        this.loading.submit = true
        this.form_create.validateFields( async (err, values) => {
          if(err){
            this.loading.submit = false
            return
          }

          try {
            const formData = new FormData()
            formData.append('kategori', values.category)
            formData.append('tahun', values.year.format('YYYY'))
            formData.append('nama_pekerjaan', values.work_name)
            formData.append('nilai_kontrak', values.contract_value)
            formData.append('omzet', values.omzet)
            formData.append('beban_proyek', values.beban_proyek)
            formData.append('komisi', values.commition_value)
            formData.append('laba_kotor', values.gross_profit)
            formData.append('efektivitas', values.efektive)
            this.selected.year = values.year.format('YYYY')

            await axios({
              method: "POST",
              url: this.$serviceUrl + "profit_planning",
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "X-API-KEY": this.getAuth.apikey,
              },
              data: formData
            })
            this.displayMessage("success-save");
            this.loading.submit = false
            this.modalOnClose()
            this.fetchData()
          } catch (error) {
            this.loading.submit = false
            console.log(error);
            this.modalOnClose()
          }
        })
      }

    },
}

</script>

<style lang="less">
.c_annualPlafon {
  .ant-card-head-title{
    margin-right: 0px!important;
  }
  .cmain-title{
    max-width: 50%;
    text-wrap: auto;
    word-break: normal;
  }
  .cbtn-create {
    i {color: #fff;}
    path{color: #fff;}
    span {color: #fff;}
  }
  .hdr_plfn{
    .ant-table-title{
      padding-bottom: 0px;
    }
  }
  .option_plfn{
    td{
    padding: 0px;
    }
  }
  .hdr_plfn_selection{
    padding: 16px;
    cursor: pointer;
  }
  .hdr_plfn_selection.isfocused  {
    background-color: fade(@color-secondary, 5%);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.25), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
    border-left-style: solid;
    border-left-color: @color-secondary;
  }
  .row-ecv{
    .ant-input-number{
      justify-content: flex-end;
    }
    .ant-input-number-input{
      text-align: right;
      display: block;
    }
  }
  .row_h{
    margin-right: 11px;
  }

  .ngabango{
    background-color: fade(@color-primary, 35%);
  }
}

.cAnnualfromcreate{
  .ant-input-number-input{
    text-align: right;
    padding-right: 25px;
  }
}

.plafonformtables{
  // .ant-table-row {
    .ant-table-thead {
      background: #c1c1c1;
      font-weight: bolder;
    }
    tr:first-child {
      td:hover {
        background: #00ca8e;
      }
    }
    td:nth-child(4){
      background: #c1c1c1;
    }

    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td, 
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY) > td {
      background: none;
    }

    .ant-table-thead > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-thead > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
    .ant-table-tbody > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background: #c1c1c1;
    }
  // }
}

.overvalueRow{
  background-color: fade(@color-primary, 35%);
}

.custom-card .ant-card-body {
  padding: 0px !important;
}

.custom-table .ant-table {
  border: none !important;
}

.custom-table .ant-table-container {
  border-inline-start: none !important;
  border-top: none !important;
}

.custom-table .ant-table-bordered > .ant-table-container {
  border: none !important;
}

.single-parent {
  text-transform: uppercase;
  font-weight: bold;
}

.summary-row td {
  background: #f3e8e8 !important;
  font-weight: bold;
}

.chart-container{
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-big-text .ant-progress-text {
  font-size: 22px !important;
  font-weight: bold;
}

.footer-card {
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

</style>